<template>
  <v-app style="background: white !important">
    <img src="static/images/vevox-logo.svg" class="headerImage" v-if="$vuetify.breakpoint.mdAndUp"/>
    <v-main class="fill-height align-sm-center">
      <router-view v-if="!$root.pageLoading" class="signupContent mx-auto"/>
    </v-main>
    <confirm-dialog ref="confirmdialog"></confirm-dialog>
    <center>
      <v-progress-circular
        v-if="$root.pageLoading"
        :width="3"
        color="primary"
        indeterminate
        class="mt-5"
      ></v-progress-circular>
    </center>
    <Watermark></Watermark>
    <cookie-banner @updated="initExternalToolsAndTrackers()" :persistent="true"/>
    <img class="leftImage" src="static/images/vevox/paint_pattern_left3.svg" alt="" v-show="$vuetify.breakpoint.mdAndUp">
    <img class="bottomRightImage" src="static/images/vevox/ElectricityBolt.svg" alt="">
  </v-app>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog';
import analytics from '@/analytics';
import trustpilot from '@/trustpilot';
import Watermark from '@/components/Watermark';
import cookieconsent from '@/js/cookieconsent'
import CookieBanner from '@/components/cookies/CookieBanner';

export default {
  name: 'signup',
  components: {
    ConfirmDialog,
    Watermark,
    CookieBanner,
  },
  data() {
    return {
      hasInitializedExternal: false,
    }
  },
  methods: {
    confirm: function(message, callback) {
      return this.$refs.confirmdialog.confirm(message, callback);
    },
    alert: function(message, callback) {
      return this.$refs.confirmdialog.alert(message, callback);
    },
    initExternalToolsAndTrackers() {
      if (this.hasInitializedExternal) return;
      this.hasInitializedExternal = true;

      if (cookieconsent.hasAcceptedPerformance()) {
        analytics.startAnalytics('MM2NPKX');    //Pull GTM account
      }
      if (cookieconsent.hasAcceptedFunctional()) {
        trustpilot.initTrustpilot();
      }
    }
  },
  mounted() {
    if (cookieconsent.hasAcceptedCookies()) {
      this.initExternalToolsAndTrackers();
    }
  },
}
</script>

<style lang="scss">
@import '../../../css/default.scss';
@import '../../../css/font.css';

.signupContent {
  max-width: 1080px !important;
  z-index: 1;
  position: relative;
}

.headerImage {
  position: fixed;
  width: 128px;
  margin-left: 32px;
  margin-top: 24px;
}

.leftImage {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: auto;
  z-index: 0;
}

.bottomRightImage {
  position: fixed;
  bottom: 0;
  right: 0;
  transform: translate(30%, 20%);
  max-width: 24vw;
  z-index: 0;
}


.iti__selected-flag {
  background-color: transparent !important;
}

@media only screen and (max-width: 1366px) {
   .headerImage {
    display: none;
  }
}

@media only screen and (max-width: 1600px) {
  .bottomRightImage {
		max-width: 16vw;
	}
  .headerImage {
    margin-left: 24px;
    width: 112px;
  }
}

@media only screen and (max-width: 1366px), (max-height: 720px)  {
  .bottomRightImage {
		display: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/index/signup/index.vue